<template>
  <label :for="target" @click="onClick"><slot /></label>
</template>

<script>
// <label for> focuses inputs natively; contenteditable fields are not labelable, so focus them by hand.
export default {
  props: {
    target: {type: String, required: true},
  },
  methods: {
    onClick(event) {
      const el = document.getElementById(this.target);
      if (!el || !el.isContentEditable) return;
      event.preventDefault();
      el.focus();
      const range = document.createRange();
      range.selectNodeContents(el);
      range.collapse(false);
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
    },
  },
};
</script>
